module.exports = __webpack_public_path__ + "media/images/color_admin_v3/gallery/gallery-8-16972a3063d02c83f0e90a4d02184349.jpg";